import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-izvestaj-toolbar',
  templateUrl: './izvestaj-toolbar.component.html',
  styleUrls: ['./izvestaj-toolbar.component.scss'],
})
export class IzvestajToolbarComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/izvestaj-toolbar/izvestaj-toolbar.component.ts